/**
 * @deprecated This file is kept for backward compatibility only.
 * All course data should be fetched from the database via UnifiedCourseService.
 * DO NOT ADD NEW COURSES HERE - use database migrations instead.
 */

import { DataScienceCourse } from './types';
import { DATASCIENCE_FUNDAMENTALS_COURSE } from './fundamentals';
import { DATASCIENCE_INTERMEDIATE_COURSE } from './intermediate';
import { DATASCIENCE_ADVANCED_COURSE } from './advanced';

export const DATASCIENCE_COURSES: DataScienceCourse[] = [
  DATASCIENCE_FUNDAMENTALS_COURSE,
  DATASCIENCE_INTERMEDIATE_COURSE,
  DATASCIENCE_ADVANCED_COURSE
];

// Export individual courses for direct access
export { 
  DATASCIENCE_FUNDAMENTALS_COURSE,
  DATASCIENCE_INTERMEDIATE_COURSE,
  DATASCIENCE_ADVANCED_COURSE
};

// Export types
export * from './types';

// Course metadata for easy reference
export const DATASCIENCE_COURSE_METADATA = {
  totalCourses: DATASCIENCE_COURSES.length,
  totalDuration: '48-58 hours',
  levels: ['fundamentals', 'intermediate', 'advanced'],
  skillsPath: [
    'Statistical Analysis & Probability',
    'Python Programming for Data Science',
    'Data Manipulation & Cleaning',
    'Exploratory Data Analysis',
    'Machine Learning Fundamentals',
    'Advanced Analytics & A/B Testing',
    'Feature Engineering & Model Selection',
    'Time Series Analysis & Forecasting',
    'Big Data Tools & Technologies',
    'MLOps & Production Deployment',
    'Data Architecture & Engineering',
    'Business Analytics & Strategy',
    'Advanced Machine Learning',
    'Causal Inference & Experimental Design',
    'Data Leadership & Team Management'
  ]
};
